// extracted by mini-css-extract-plugin
module.exports = {"cursor":"IconAdd_cursor__1M1zt","root":"IconAdd_root__5F_VP"};